import { IBlobSasModel, IIntakePetModel, IntakePetModel } from "@common/models";
import { BlobEntityType } from "@common/models/Enums";
import { ImageService, IntakeService } from "@common/services";
import { AzureBlobStore } from "@common/stores";
import { IntakeStore } from "@customer/stores";
import { each } from "lodash";
import {
  action,
  flow,
  IObservableArray,
  makeObservable,
  observable,
  runInAction,
} from "mobx";

export interface ISection {
  name: string;
}

export class IntakePetStore {
  intakeStore!: IntakeStore;
  blobStore!: AzureBlobStore;
  @observable progressSections: IObservableArray<ISection> = observable([
    { name: "petprofile" },
  ]);
  @observable selectedSectionIndex: number = -1;
  @observable sectionWidth: number = 0;
  @observable selectedPet: IntakePetModel = new IntakePetModel();

  constructor(intakeStore: IntakeStore) {
    this.intakeStore = intakeStore;

    if (!this.blobStore)
      this.blobStore = new AzureBlobStore({
        containerName: BlobEntityType.IntakePet,
      });

    makeObservable<IntakePetStore>(this, undefined, {
      autoBind: true,
    });
  }

  @action.bound load(
    intakePublicId: string,
    linksource: string,
    intakePetId?: number,
  ) {
    this.intakeStore.setParamValues(intakePublicId, linksource, intakePetId);

    this.fetchIntakeSelectedPet();
  }

  @action.bound nextSection() {
    this.selectedSectionIndex = this.selectedSectionIndex + 1;
  }

  @action.bound updateSelectedQuestionListValue(
    listValueId: number,
    sectionIdx: number,
    questionIdx: number,
  ) {
    this.selectedPet.sections[sectionIdx].questions[
      questionIdx
    ].intakePetSectionQuestionListValues.forEach((val) => {
      val.isSelected = val.intakePetSectionQuestionListValueId === listValueId;
    });

    return this.selectedPet.sections[sectionIdx].questions[questionIdx];
  }

  fetchIntakeSelectedPet = flow(function* (this: IntakePetStore) {
    yield this.intakeStore.getIntake().then(() => {
      const selectedPet = this.intakeStore.selectedPet;

      runInAction(() => {
        if (selectedPet) {
          each(selectedPet.sections, (s) => {
            this.progressSections.push({ name: s.name } as ISection);
          });

          this.sectionWidth = 100 / this.progressSections.length - 3;

          this.selectedPet = selectedPet;
        }
      });
    });
  });

  updateIntakePet = flow(function* (
    this: IntakePetStore,
    intakePet: IIntakePetModel,
  ) {
    return yield IntakeService.updateIntakePet(
      intakePet,
      this.intakeStore.linkSource,
      { showError: true },
    );
  });

  savePetPhoto = flow(function* (this: IntakePetStore, petPhotoFile: File) {
    if (petPhotoFile) {
      const blobSas: IBlobSasModel = yield this.blobStore.uploadFile(
        petPhotoFile,
        this.selectedPet.intakePetId,
        true,
      );
      if (blobSas) {
        // Intake must already exist.
        return yield ImageService.uploadIntakePetPhotoPublic(blobSas, {
          showSuccess: true,
          showError: true,
        }).then((intakePet) => {
          runInAction(() => {
            this.selectedPet = intakePet;
          });
        });
      }
    }

    return;
  });
}
